import { onDocumentReady } from '@theme/utilities';
import { StandardEvents } from '@shopify/events';
import { publish } from '@theme/analytics';

const LOGIN_STATE_KEY = 'fascar:customer-logged-in';

function publishPageView() {
  const main = document.querySelector('main[data-template]');
  const pageCategory = /** @type {HTMLElement | null} */ (main)?.dataset.pageCategory;

  /** @type {Record<string, unknown>} */
  const data = {};
  if (pageCategory) data.page_category = pageCategory;

  publish('page_view', data);
}

function publishNewsletterSignupIfSuccessful() {
  if (!document.querySelector('[data-analytics-success="newsletter"]')) return;
  publish('registration_newsletter', {});
}

// Shopify's hosted Customer Accounts login flow runs on a separate origin (no theme JS
// runs there), so there's no click/submit to hook. Instead, detect the id-appearing edge
// on return: compare the previous page's logged-in state (persisted here) against the
// current one, and only publish when it flips from logged-out to logged-in. A missing
// previous state (first run after deploy, or a brand new session) just seeds the baseline
// without publishing, so an already-logged-in visitor doesn't get a spurious login event.
function publishLoginIfJustAuthenticated() {
  const isLoggedIn = !!window.Theme?.customer?.id;
  const previousState = localStorage.getItem(LOGIN_STATE_KEY);

  if (previousState === 'false' && isLoggedIn) {
    publish('login', {});
  }

  localStorage.setItem(LOGIN_STATE_KEY, String(isLoggedIn));
}

onDocumentReady(() => {
  publishPageView();
  publishNewsletterSignupIfSuccessful();
  publishLoginIfJustAuthenticated();
});

// Collection filters and search-page filtering update the URL via history.pushState
// without a full reload (see assets/facets.js) — these already-dispatched standard
// events are the signal to treat that as a new virtual page_view.
document.addEventListener(StandardEvents.collectionUpdate, publishPageView);
document.addEventListener(StandardEvents.searchUpdate, publishPageView);
